import { store } from '../index';
import axios from 'axios';
import {
	TOKEN_KEY,
	STORE,
	OFFERS,
	ASSOCIATED_STORE,
	SEND_EMAIL,
	CHARGES
} from './constant';

let optionAxios = {
	headers: {
		'Access-Control-Allow-Origin': '*',
		'Content-Type': 'application/json',
		"x-api-source": "webapp"
	},
};


const store_order = async (input) => {
	let user = store.getState().sessionReducer || {};
	const {token, store_id} = user;
	input = { ...input, store_id};
	optionAxios.headers.authorization = token;
	return await axios
	.post(STORE, input, optionAxios)
	.then(function(resp) {
		return resp.data.data;
	})
	.catch((error) => {
		if(error?.response?.status === 401){
			window.location.href = "/rescan";
		}
	});
};

const store_offer = async (input) => {
	let user = store.getState().sessionReducer || {};
	const {token, store_id} = user;
	input = { ...input, store_id};
	optionAxios.headers.authorization = token;
	return await axios
	.post(OFFERS, input, optionAxios)
	.then(function(resp) {
		return resp.data.data;
	})
	.catch((error) => {
		if(error?.response?.status === 401){
			window.location.href = "/rescan";
		}
	});
};

const associated_store = async ({ token, store_id } = {}) => {
	console.log('[associated_store] called', { has_token: !!token, store_id });
	if (!token || !store_id) {
		console.log('[associated_store] EXIT — missing token or store_id');
		return null;
	}
	optionAxios.headers.authorization = token;
	return await axios
	.post(ASSOCIATED_STORE, { store_id }, optionAxios)
	.then(function(resp) {
		console.log('[associated_store] response', {
			status: resp?.status,
			data_length: resp?.data?.data?.length,
		});
		return resp.data.data;
	})
	.catch((error) => {
		console.error('[associated_store] error', {
			status: error?.response?.status,
			data: error?.response?.data,
			message: error?.message,
		});
		if(error?.response?.status === 401){
			window.location.href = "/rescan";
		}
	});
};

const store_charges = async (input) => {
	let user = store.getState().sessionReducer || {};
	const {token, store_id} = user;
	input = { ...input, store_id};
	optionAxios.headers.authorization = token;
	return await axios
	.post(CHARGES, input, optionAxios)
	.then(function(resp) {
		return resp.data;
	})
	.catch((error) => {
		if(error?.response?.status === 401){
			window.location.href = "/rescan";
		}
	});
};


const send_email = async (input) => {
	let user = store.getState().sessionReducer || {};
	const {token, store_id} = user;
	input = { ...input, store_id};
	optionAxios.headers.authorization = token;
	return await axios
	.post(SEND_EMAIL, input, optionAxios)
	.then(function(resp) {
		return resp.data.data;
	})
	.catch((error) => {
		if(error?.response?.status === 401){
			window.location.href = "/rescan";
		}
	});
};

export {
	store_order,send_email,
	store_offer,store_charges,
	associated_store
};
